export const lang = 'pl'



// WEBPACK FOOTER //
// ./src/translations/lang.js